.captcha {
  display: flex;
  justify-content: center;
  margin: 0 0 8px;
  min-height: 65px;
}

.error {
  font: var(--font-caption-lg-medium);
  font-weight: 400;
  color: var(--semantic-colors-typography-error);
  text-align: center;
}
